import { render, staticRenderFns } from "./KioskWelcome.vue?vue&type=template&id=6d36a85a&scoped=true&"
import script from "./KioskWelcome.vue?vue&type=script&lang=js&"
export * from "./KioskWelcome.vue?vue&type=script&lang=js&"
import style0 from "./KioskWelcome.vue?vue&type=style&index=0&id=6d36a85a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d36a85a",
  null
  
)

export default component.exports